import { useEffect } from "react";
import { Toaster, toast } from "sonner";
import "./notifications.scss";

export function AppToaster() {
    useEffect(() => {
        const dismissOnToastClick = (event: MouseEvent) => {
            const target = event.target as HTMLElement | null;
            const toastElement = target?.closest<HTMLElement>("[data-sonner-toast].app-toast[data-testid^='app-toast-']");
            if (!toastElement) return;

            const toastId = toastElement.dataset.testid?.replace(/^app-toast-/, "");
            if (toastId) toast.dismiss(toastId);
        };

        document.addEventListener("click", dismissOnToastClick);
        return () => document.removeEventListener("click", dismissOnToastClick);
    }, []);

    return (
        <Toaster
            closeButton={false}
            position="top-right"
            visibleToasts={1}
            offset={{ top: 58, right: 22 }}
            mobileOffset={{ top: 58, right: 14, left: 14 }}
            swipeDirections={[]}
            toastOptions={{
                closeButton: false,
                classNames: {
                    toast: "app-toast",
                    title: "app-toast-title",
                    description: "app-toast-description",
                    loader: "app-toast-loader",
                    closeButton: "app-toast-close",
                    actionButton: "app-toast-action",
                    cancelButton: "app-toast-cancel",
                    icon: "app-toast-icon",
                },
            }}
        />
    );
}
